import { render, staticRenderFns } from "./aiDesign.vue?vue&type=template&id=856ae3b0&scoped=true"
import script from "./aiDesign.vue?vue&type=script&lang=js"
export * from "./aiDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856ae3b0",
  null
  
)

export default component.exports